import { Modal } from '@lib/components'
import { Button } from '@octopus-do/octopus-storybook'
import { Copy } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { useDispatch } from 'react-redux'

import type { IssuedApiKey } from '@/services/apiKeys'
import { GlobalActions } from '@/store'
import type { ModalProps } from '@/types'
import css from './styles.module.scss'

interface Props extends ModalProps {
  issued: IssuedApiKey
}

export const ApiKeyCreated: React.FC<Props> = ({ onClose, issued }) => {
  const dispatch = useDispatch()

  const handleCopy = () => {
    dispatch(GlobalActions.copy({ value: issued.key }))
  }

  return (
    <Modal classnames={{ content: css.modal }} onClose={onClose}>
      <div className={css.container}>
        <div className={css.title}>API key created</div>
        <div className={css.description}>
          <b>{issued.name}</b> is ready. Copy it now — for security reasons we
          won’t be able to show it again.
        </div>

        <textarea value={issued.key} className={css.code} readOnly />

        <Button label="Copy" left={Copy} onClick={handleCopy} />
      </div>
    </Modal>
  )
}
